import React, { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { ChevronDown } from "lucide-react";

const linkCls = ({ isActive }) =>
  `flex items-center gap-3 px-3 py-2 rounded-md text-sm transition-colors ${
    isActive ? "bg-norea-surfaceHover text-norea-primary font-medium" : "text-norea-textMuted hover:bg-norea-surfaceHover hover:text-norea-text"
  }`;

export function NavItem({ item, sub }) {
  return (
    <NavLink to={item.to} end={item.to === "/" || item.end} data-testid={item.testid} className={(s) => `${linkCls(s)} ${sub ? "py-1.5" : ""}`}>
      {item.icon && <item.icon className="w-4 h-4" />}
      <span>{item.label}</span>
    </NavLink>
  );
}

export function NavGroup({ group, isAdmin }) {
  const { pathname } = useLocation();
  const children = group.children.filter((c) => !c.adminOnly || isAdmin);
  const active = children.some((c) => pathname.startsWith(c.to));
  const [open, setOpen] = useState(active);
  return (
    <div>
      <button onClick={() => setOpen((o) => !o)} data-testid={group.testid} aria-expanded={open}
        className={`w-full flex items-center gap-3 px-3 py-2 rounded-md text-sm transition-colors hover:bg-norea-surfaceHover ${active ? "text-norea-primary font-medium" : "text-norea-textMuted hover:text-norea-text"}`}>
        <group.icon className="w-4 h-4" />
        <span className="flex-1 text-left">{group.label}</span>
        <ChevronDown className={`w-3.5 h-3.5 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="ml-5 pl-2 border-l border-norea-border space-y-0.5 mt-0.5" data-testid={`${group.testid}-children`}>
          {children.map((c) => <NavItem key={c.to} item={c} sub />)}
        </div>
      )}
    </div>
  );
}
